import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const StyledSection = styled.div`
  background-image: url(${props => props.url});
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  overflow: hidden;
  height: 70vh;
  margin: 4rem;
  padding-top: 4rem;
  padding-left: 10rem;

  h1 {
    font-size: 46px;
    color: #ffffff;
    font-weight: 700;
    line-height: 48px;
    overflow: hidden;
  }
  h4 {
    font-size: 18px;
    line-height: 32px;
    color: #ffffff;
    font-weight: 600;
  }
  .btn-area {
    margin-top: 2rem;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    border: 1px solid #fff;
    padding-left: 3rem;
    padding-right: 3rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 18px;
    color: #ffffff;
    font-weight: 600;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.md)} {
    padding-left: 5rem;
    margin: 2rem;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    padding-left: 2rem;
    margin: 10px;
    .btn-area {
      padding-left: 2rem;
      padding-right: 2rem;
      font-size: 16px;
    }
  }
`
const CallUs = ({ data }) => {
  const { acf } = data

  return (
    <StyledSection
      url={acf.cta_background_image ? acf.cta_background_image.url : null}
    >
      <h4>Call Us For Free Consultation!</h4>
      <h1>
        Need More <br /> Information?
      </h1>
      <h1></h1>
      <br />
      <Link to="/contact">
        <a className="btn-area">Call To Free Consulation</a>
      </Link>
    </StyledSection>
  )
}

export default CallUs
